<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VV9ucY/tc-custom/9781398486171.jpg?1705541262437" alt="This image is the cover for the book The Island of Mora Mora: A Journey into Madagascar"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Island of Mora Mora: A Journey into Madagascar
      </h1>
      <p class="bookDescription body article font2">
        <p>Mora Mora – Things on the Island of Madagascar happen slowly or they don’t happen at all. Set your patience to full, adjust your expectations for anything, and be prepared to witness some of the world’s most fascinating experiences. Madagascar’s natural history is its national treasure but its present and future is dire. Caught in a Malthusian Trap, the population is expanding, and the disappearance of the originalnatural landscape is all but complete. This book captures the island at an important time in its history, because whether the future will be better or worse, it will be different. Join author Tyrel Cameron Eskelson on his solitary adventurous journey to four corners of the island of Madagascar, in the overcrowded taxi-brousse, a notorious sinking ferry, old colonial trains, sketchy motorcycle rides, ox-driven carts, and at other times he straps on his pack and walks several days through the secluded rainforest mountains. He witnesses shamans as they summon the spirits of the dead, and at other times wakes up feeling like death after a night drinking the local spirits. He interacts with scientists, dodges scallywags, and at times goes right inside the homes of the local people. Driven by curiosity, Eskelson brings the island to life with his eye for detail and command of history. Full of humorous observations and exciting encounters, this book is an example of the future of good old-fashioned travel writing. Whether you’re on an adventure or waiting for your next one, this unique tale of travel will entertain, inspire, and make you wish there was more.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tyrel Cameron Eskelson
      </h2>
      
      <p class="authorDescription body article">Tyrel grew up in central Canada in the Prairie town of Rosetown Saskatchewan. Since 2017, he has been working for Hokkaido University’s Faculty of Education where he currently holds a DX Fellowship and is in the final stages of completing a PhD. He currently lives in the city of Sapporo, Japan, where he splits his time between his family and reading and writing history and travel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5ed872eb